import { CacheExpiryForARIApi } from '../shared/constants/global.constants';
import { ApiService } from '../shared/services/api-service/api.service';
import { CommonService } from '../shared/services/common-service/common.service';
import { IBasicAvailAPIResponse, IRequestBasicAvailPayloadOptions } from './interfaces/basic-avail.interfaces';
/**
 * @ignore
 */
declare const TCCommonService;
class BasicAvail {
    async getBasicAvailability(requestBasicAvailPayloadOptions: IRequestBasicAvailPayloadOptions,
        enableApiCaching: boolean = false, tcShareLocation?: boolean) {
        requestBasicAvailPayloadOptions.roomSequenceNumber = String(requestBasicAvailPayloadOptions.roomSequenceNumber);
        const payload = JSON.stringify(requestBasicAvailPayloadOptions);
        let cacheKey;
        if (tcShareLocation || tcShareLocation === false) {
            cacheKey = 'be_' + TCCommonService.ConfigService.getPlatformType() + '_wc_basic_avail_' +
                requestBasicAvailPayloadOptions.hotelCode + tcShareLocation + '_' + CommonService.generateHashCode(payload);
        } else {
            cacheKey = 'be_' + TCCommonService.ConfigService.getPlatformType() + '_wc_basic_avail_' +
                requestBasicAvailPayloadOptions.hotelCode + '_' + CommonService.generateHashCode(payload);
        }
        if (enableApiCaching) {
            const basicAvailDataFromCache = TCCommonService.BrowserStorageService.getBrowserStorage({
                key: cacheKey,
                expiryTime: CacheExpiryForARIApi
            });
            if (basicAvailDataFromCache) {
                return basicAvailDataFromCache;
            }
        }

        try {
            delete requestBasicAvailPayloadOptions.roomSequenceNumber;
            const basicAvailApiResponse: Response = await ApiService.callBasicAvailApi
                (requestBasicAvailPayloadOptions.hotelCode, requestBasicAvailPayloadOptions, tcShareLocation);
            const basicAvailObject: IBasicAvailAPIResponse = await basicAvailApiResponse.json();
            if (enableApiCaching) {
                TCCommonService.BrowserStorageService
                    .setBrowserStorage({ key: cacheKey, value: basicAvailObject });
                TCCommonService.CacheTrackingService
                    .setCacheTracking({ key: 'basicAvail', value: cacheKey});
            }
            return basicAvailObject;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }
}

export const BasicAvailService = new BasicAvail();
